import { useEffect } from 'react';

import { RefreshToken, Token } from '../constants/keys';
import { PageLayout } from '../components/PageLayout';
import { useLogout } from '../hooks';
import { setVh } from '../utils/ui';
// import { DevicesQRCodeLinkKey } from '../components/Devices/constants/index.jsx';
// import { useSearchParams } from 'react-router-dom';

// import { App } from '@capacitor/app';
// import { Badge } from '@capawesome/capacitor-badge';

// App.addListener('appStateChange', async (state) => {
// console.log('====AppStateChange====', state.isActive);
// if (state.isActive) {
//   await Badge.clear();
// }
// }).then();

const BasePage = () => {
  const accessToken = localStorage.getItem(Token);
  const refreshToken = localStorage.getItem(RefreshToken);

  const logoutUser = useLogout();

  useEffect(() => {
    setVh();

    // Re-calculate on resize
    window.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);

  useEffect(() => {
    if (!accessToken || !refreshToken) {
      // Logout
      logoutUser().then();
    }
  },[accessToken, refreshToken]);

  return accessToken && refreshToken && <PageLayout />;
};

export default BasePage;
